import { API_ROUTES } from '@/constants/apiRoutes';
import {
  ApproveDeclineTransactionReviewRequestBody,
  TransactionReviewDetails,
  TransactionReviewListResponse,
} from '@/types/transactionReview';
import { api } from '@/utils/api';

export const getTransactionReviewListService = async (queryParams: string) => {
  const { data } = await api<TransactionReviewListResponse>({
    url: `${API_ROUTES.TRANSACTION_REQUEST}${API_ROUTES.UNDER_REVIEW}?${queryParams}`,
    method: 'get',
    version: 2,
  });

  return data;
};

export const getTransactionReviewDetailsService = async (uuid: string) => {
  const { data } = await api<TransactionReviewDetails>({
    url: `${API_ROUTES.TRANSACTION_REQUEST}${API_ROUTES.UNDER_REVIEW}/${uuid}`,
    method: 'get',
    version: 2,
  });

  return data;
};

export const declineTransactionReviewService = async (
  payload: ApproveDeclineTransactionReviewRequestBody,
) => {
  const { id, dueDiligenceNotes } = payload;
  const { status } = await api({
    url: `${API_ROUTES.TRANSACTION_REQUEST}${API_ROUTES.UNDER_REVIEW}/${id}/decline`,
    method: 'post',
    version: 2,
    data: {
      due_diligence_notes: dueDiligenceNotes,
    },
  });

  return status;
};

export const approveTransactionReviewService = async (
  payload: ApproveDeclineTransactionReviewRequestBody,
) => {
  const { id, dueDiligenceNotes } = payload;
  const { status } = await api({
    url: `${API_ROUTES.TRANSACTION_REQUEST}${API_ROUTES.UNDER_REVIEW}/${id}/approve`,
    method: 'post',
    version: 2,
    data: {
      due_diligence_notes: dueDiligenceNotes,
    },
  });

  return status;
};
